module.exports = __webpack_public_path__ + "img/head2@2x.b5308cc1.png";